var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClipboardCheck = function SvgClipboardCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "inherit",
    viewBox: "0 0 21 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.19 2.056a2.14 2.14 0 0 0-.628 1.515v14.286A2.143 2.143 0 0 0 4.705 20h12.143a2.143 2.143 0 0 0 2.143-2.143V3.571a2.143 2.143 0 0 0-2.143-2.142H4.705c-.568 0-1.114.225-1.515.627m12.218 7.078c.04.282-.033.567-.203.795l-4.286 5.714a1.07 1.07 0 0 1-1.451.248l-2.143-1.428a1.071 1.071 0 0 1 1.188-1.783l1.3.866 3.678-4.903a1.071 1.071 0 0 1 1.917.491",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.245.469A1.6 1.6 0 0 1 8.376 0h4.8a1.6 1.6 0 0 1 1.6 1.6v.8a1.6 1.6 0 0 1-1.6 1.6h-4.8a1.6 1.6 0 0 1-1.6-1.6v-.8A1.6 1.6 0 0 1 7.245.469"
  })));
};
export default SvgClipboardCheck;